import { Box, TextField } from "@mui/material";
import { colors } from "../../../ui/colors";

export const VerificationCodeInput = ({ 
  code, 
  inputsRef, 
  handleChange, 
  handleKeyDown, 
  handlePaste, 
  isDisabled 
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1, mb: 3 }}>
      {code.map((digit, index) => (
        <TextField
          key={index}
          margin="normal"
          required
          inputProps={{ 
            maxLength: 1, 
            inputMode: "numeric",
            'aria-label': `Digit ${index + 1}`
          }}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          inputRef={(ref) => (inputsRef.current[index] = ref)}
          disabled={isDisabled}
          sx={{
            flex: 1,
            '& .MuiOutlinedInput-root': {
              borderRadius: '12px',
              backgroundColor: colors.warmWhite.base,
              textAlign: 'center',
              '& fieldset': {
                borderColor: colors.orange[200],
                borderWidth: '2px',
              },
              '&:hover fieldset': {
                borderColor: colors.orange[400],
              },
              '&.Mui-focused fieldset': {
                borderColor: colors.orange.base,
              },
              '& input': {
                textAlign: 'center',
                fontSize: '18px',
                fontWeight: 600,
              },
            },
          }}
        />
      ))}
    </Box>
  );
};



